var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-code',{attrs:{"title":"Single Slider"},scopedSlots:_vm._u([{key:"code",fn:function(){return [_vm._v(" "+_vm._s(_vm.codeSingle)+" ")]},proxy:true}])},[_c('vue-slider',{attrs:{"direction":_vm.direction},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }